import React from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { confirmAuthentaLink, clearAuthentaLinkError, AuthState } from 'actions';
import { getOnlineConfig } from 'actions/app';
import { history } from 'containers/App';

import SubmitButton from 'components/Common/Buttons';
import ModalWrapper from 'components/Modals/ModalWrapper';
import LocalisedMessage from 'components/Common/LocalisedMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AuthentaLinkReferenceConfirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      uniqueRef: '',
      name: ''
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onSubmitAuth = this.onSubmitAuth.bind(this);
  }

  componentDidMount() {
    this.redirectOnAuthorised();

    const { location } = this.props;
    const queryParams = new URLSearchParams(location.search);
    const uniqueRefOnly = queryParams.has('uniqueRefOnly') ? queryParams.get('uniqueRefOnly') === 'true' : false;

    this.setState({ uniqueRefOnly });
  }

  componentDidUpdate() {
    this.redirectOnAuthorised();
  }

  onCloseError() {
    const { dispatch } = this.props;
    dispatch(clearAuthentaLinkError());
  }

  onInputChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  onSubmitAuth(event) {
    const { dispatch } = this.props;
    const { email, uniqueRef, name, uniqueRefOnly } = this.state;

    event.preventDefault();
    dispatch(confirmAuthentaLink(email, uniqueRef, name, uniqueRefOnly));
  }

  redirectOnAuthorised() {
    const { authState, dispatch } = this.props;

    if (authState === AuthState.Authorised) {
      dispatch(getOnlineConfig());
      history.push('/');
    }
  }

  render() {
    const { isAuthenticating, isFailed, errorMessage, intl } = this.props;
    const { email, uniqueRef, name, uniqueRefOnly } = this.state;
    return (
      <form autoComplete="off" onSubmit={ e => this.onSubmitAuth(e) } id="authentaLinkDetails" className="authentalink cards">
        <div className="card mt-4 offset-1 col-10 offset-lg-2 col-lg-8 offset-xl-3 col-xl-6">
          <LocalisedMessage id="authentalink.confirmation.title" />
          <p>{intl.formatMessage({ id: 'authentaLink.enterCode.instructions' })}</p>
          <section className="section">
            <div className="row pb-3">
              {!uniqueRefOnly && <div className="col">
                <label htmlFor="email">{intl.formatMessage({ id: 'authentalink.confirmation.emailAddressLabel' })}</label>
                <input id="email" name="email" type="text" value={ email } onChange={ this.onInputChange } />
              </div> }
            </div>
            <div className="row pb-3">
              <div className="col">
                <label htmlFor="uniqueRef">{intl.formatMessage({ id: 'authentalink.confirmation.uniqueRefLabel' })}</label>
                <input id="uniqueRef" name="uniqueRef" type="text" value={ uniqueRef } onChange={ this.onInputChange } />
              </div>
            </div>
            <div className="row pb-3">
              {!uniqueRefOnly && <div className="col">
                <label htmlFor="customerName">{intl.formatMessage({ id: 'authentalink.confirmation.nameLabel' })}</label>
                <input id="customerName" name="name" type="text" value={ name } onChange={ this.onInputChange } />
              </div>}
            </div>
          </section>
          <SubmitButton type="Submit" value={ intl.formatMessage({ id: 'authentalink.confirmation.buttonText' }) } disabled={ isAuthenticating } className={ `btn-primary${ isAuthenticating ? ' btn-active' : '' }` } />
        </div>
        { !isAuthenticating && isFailed && <ModalWrapper
          title=""
          closeButtonName={ intl.formatMessage({ id: 'authentaLink.failed.title' }) }
          className="ref-confirmation-modal"
          showCancel={ false }
          onCancel={ () => this.onCloseError() }
          onConfirm={ () => this.onCloseError() }
          disableConfirm={ false }
          btnConfirmTitle={ intl.formatMessage({ id: 'buttons.close' }) }
          btnConfirmClass="col-5"
          content={
            <div className="col text-center">
              <FontAwesomeIcon icon="exclamation-circle" size="3x" className="mt-2 mb-3" /><br />
              <LocalisedMessage id="authentalink.confirmation.error.title" />
              { errorMessage || <LocalisedMessage id="authentalink.confirmation.error.generalMessage" /> }
            </div>
          }
        /> }
        <div className="offset-1 col-10 offset-lg-2 col-lg-8 offset-xl-3 col-xl-6 pr-0 protected-by-authentalink">
          <div className="powered-by text-right text-top">{ intl.formatMessage({ id: 'authentalink.confirmation.formFooter' }) } <div className="logo-nameonly" /> Authent-A-Link</div>
        </div>
      </form>
    );
  }
}

AuthentaLinkReferenceConfirmation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  authState: PropTypes.string,
  isAuthenticating: PropTypes.bool,
  isFailed: PropTypes.bool,
  errorMessage: PropTypes.string,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

AuthentaLinkReferenceConfirmation.defaultProps = {
  authState: AuthState.Unknown,
  isAuthenticating: false,
  isFailed: false,
  errorMessage: null
};

function mapStateToProps(state) {
  const {
    app: { authState },
    authentaLink: { isAuthenticating, isFailed, errorMessage }
  } = state;

  return {
    authState,
    isAuthenticating: isAuthenticating && true,
    isFailed: isFailed && true,
    errorMessage
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AuthentaLinkReferenceConfirmation));
